import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-CDesign";
import leftimgs from "../../../assets/phpleftimg.png";
import rightimgs from "../../../assets/phprightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/php-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/php-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/php-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/php-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/php-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/php-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/php-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/php-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/php-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/phpFun-img1.png";
import FunactivitiesImg2 from "../../../assets/phpFun-img2.png";
import FunactivitiesImg3 from "../../../assets/phpFun-img3.png";
import FunactivitiesImg4 from "../../../assets/phpFun-img4.png";
import FunactivitiesImg5 from "../../../assets/phpFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "13",
      classes: "07",
      description: " PHP Basics- Learn backend web development using PHP, including variables, data types, conditions, loops, and basic database handling.",
    },
   
    
  ];

  const advancedModules = [
    {
      title: "Module 1",
      activities: "13",
      classes: "07",
      description:" Fundamentals of PHP -  Learn PHP basics including variables, data types, conditions, loops, and server-side scripting.",
    },
    {
      title: "Module 2",
      activities: "11",
      classes: "06",
      description:" Embed PHP with HTML -  Combine PHP with HTML, work with arrays, functions, and handle file input/output.",
    },
    {
      title: "Module 3",
      activities: "09",
      classes: "05",
      description:": Introduction to MySQL -  Learn MySQLi database creation, data upload, and basic queries like INSERT, UPDATE, and DELETE.",
    },
     {
      title: "Module 4",
      activities: "11",
      classes: "06",
      description:" Advanced PHP Concepts - Build login systems, handle file uploads/downloads, manage sessions, and create password features.",
    },
   
  ];


  const benefitsData = [
      {
        title: "Dynamic Websites",
        description: "Learn to create interactive and responsive sites.",
        icon: "Polymath-images/php-benefit-img1.png", //ji
      },
      {
        title: "Algorithmic Thinking",
        description: "Solve problems using logical code structures.",
        icon: "Polymath-images/php-benefit-img2.png",
      },
      {
        title: "MySQLi Basics",
        description: "Learn to store, organize, and connect data.",
        icon: "Polymath-images/php-benefit-img3.png",
      },
      {
        title: "Read & Write Data",
        description: "Handle information flow between frontend and backend.",
        icon: "Polymath-images/php-benefit-img4.png",
      },
      {
        title: "Solve math  with code",
        description: "Automate calculations through programming.",
        icon: "Polymath-images/php-benefit-img5.png",
      },
      {
        title: "Handle Form Data",
        description: "Collect, validate, and process user input.",
        icon: "Polymath-images/php-benefit-img6.png",
      },
      {
        title: "Send & Receive Data",
        description: "Communicate between systems using PHP.",
        icon: "Polymath-images/php-benefit-img7.png",
      },
      {
        title: "Modify Web Images",
        description: "Edit, resize, and manage images dynamically.",
        icon: "Polymath-images/php-benefit-img8.png",
      },
      {
        title: "Control User Access",
        description: "Protect pages using login and permission logic.",
        icon: "Polymath-images/php-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Basket Ball Game",
          image: "Polymath-images/phpFun-img1.png",
        },
        {
          title: "Dragon Land Game",
          image: "Polymath-images/phpFun-img2.png",
        },
        {
          title: "MineCraft Game",
          image: "Polymath-images/phpFun-img3.png",
        },
        {
          title: "Multiplayer Soccer Game",
          image: "Polymath-images/phpFun-img4.png",
        },
        {
          title: "Super Jumper Game",
          image: "Polymath-images/phpFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const PHP = () => {
  const Scratchpage = heroContent.phpsection;
  return (
    <>
       {/* <GuestNav/> */}
     <HeadSection
      leftImg={'Polymath-images/phpleftimg.png'}
      rightImg={'Polymath-images/phprightimg.png'}
      titlePart1="PHP Procedural"
      titlePart2="Course"
      description="An extensive course for the ambitious youngsters to learn the art of developing professional looking websites with dynamic content. Polymath-Kids offer a PHP Basic course for Grade 4 to 6 and a PHP Procedure course for Grade 7+. Students will learn to develop Algorithmic Thinking required to create an interactive website, creating and handling database, creating login and registration systems and much more."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
              title1="Course Structure & Syllabus"
              title="Beginner Level Course"
              modules={beginnerModules}
            />
            <CourseTimeline
             
              title="Advance Level Course"
              modules={advancedModules}
            />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Kidprenur Course"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default PHP